// @ts-check
import {
  SET_RENDERED_SOLUTION,
  SOLUTIONS_ARRIVED,
  EXTERNAL_WALL_MATERIAL_CHANGED
} from '../../redux/actions/actionTypes';

const initialState = {
  solutions: [],
  renderedSolution: null,
  refreshObject: {}
}

export function modelReducer(state = initialState, action) {
  switch (action.type) {
    case SOLUTIONS_ARRIVED:
      console.log('action.payload', action.payload)
      if (action.payload.solutions) {
        return {
          ...state,
          solutions: action.payload.solutions,
          renderedSolution: action.payload.solutions[0]
        }
      } else {
        return {
          ...state,
          // solutions: [],
          // renderedSolution: {}
        }
      }
    case SET_RENDERED_SOLUTION:
      return {
        ...state,
        renderedSolution: state.solutions[action.payload]
      }
    case EXTERNAL_WALL_MATERIAL_CHANGED:
      return {
        ...state,
        refreshObject: action.payload
      }
    default:
      return state;
  }
}
